import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance1el8xrhi64v9a as Companion_instance,
} from '../collections/AbstractList.mjs';
import { getOrNull1d60i0672n7ns as getOrNull } from '../collections/_Arrays.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../collections/Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from '../collections/RandomAccess.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EnumEntriesListClass;
function EnumEntriesList() {
  if (EnumEntriesListClass === VOID) {
    class $ extends AbstractList() {
      constructor(entries) {
        return new.target.wm(entries);
      }
      static wm(entries) {
        var $this = this.zi();
        $this.vm_1 = entries;
        return $this;
      }
      q2() {
        return this.vm_1.length;
      }
      r2(index) {
        Companion_instance.i7(index, this.vm_1.length);
        return this.vm_1[index];
      }
      xm(element) {
        if (element === null)
          return false;
        var target = getOrNull(this.vm_1, element.w1_1);
        return target === element;
      }
      t2(element) {
        if (!(element instanceof Enum()))
          return false;
        return this.xm(element instanceof Enum() ? element : THROW_CCE());
      }
      ym(element) {
        if (element === null)
          return -1;
        var ordinal = element.w1_1;
        var target = getOrNull(this.vm_1, ordinal);
        return target === element ? ordinal : -1;
      }
      r4(element) {
        if (!(element instanceof Enum()))
          return -1;
        return this.ym(element instanceof Enum() ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'EnumEntriesList', VOID, VOID, [KtList(), RandomAccess()]);
    EnumEntriesListClass = $;
  }
  return EnumEntriesListClass;
}
function enumEntries(entries) {
  return EnumEntriesList().wm(entries);
}
//region block: exports
export {
  enumEntries as enumEntries20mr21zbe3az4,
};
//endregion

//# sourceMappingURL=EnumEntries.mjs.map
